import { render, staticRenderFns } from "./popoverButton.vue?vue&type=template&id=00f4d622"
import script from "./popoverButton.vue?vue&type=script&lang=js"
export * from "./popoverButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports